import { createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    fontSize: 14,
  },
  spacing: (factor: number) => `${0.25 * factor}rem`,
  palette: {
    primary: {
      main: '#153085',
    },
    secondary: {
      main: '#fcdd04',
    },
  },
});

theme.components = {
  MuiAlert: {
    defaultProps: {
      variant: 'filled',
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        color: '#153085',
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      fullWidth: true,
      variant: 'outlined',
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        fontSize: '0.75rem',
        marginLeft: '0.5rem',
        marginRight: '0.5rem',
      },
    },
  },
  MuiFormControl: {
    defaultProps: {
      margin: 'none',
      hiddenLabel: true,
    },
    styleOverrides: {
      root: {
        marginTop: '0.4rem',
        marginBottom: '1rem',
      },
    },
  },
  MuiFilledInput: {
    defaultProps: {
      disableUnderline: true,
    },
    styleOverrides: {
      root: {
        border: `1px solid ${theme.palette.grey[300]}`,
        '&.Mui-error': {
          border: `1px solid ${theme.palette.error.main}`,
        },
        backgroundColor: '#fcfcfc',
        '&.Mui-focused': {
          backgroundColor: '#fcfcfc',
        },
        '&:not(.Mui-disabled):hover': {
          backgroundColor: '#fcfcfc',
          border: `1px solid ${theme.palette.grey[400]}`,
        },
        '&.Mui-disabled': {
          backgroundColor: '#fcfcfc',
          border: `1px dashed ${theme.palette.grey[300]}`,
          cursor: 'not-allowed',
          '& > input': {
            cursor: 'not-allowed',
          },
        },
        borderRadius: theme.shape.borderRadius,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: '0.75rem',
        paddingRight: '0.75rem',
      },
      input: {
        height: '1.5rem',
        padding: 0,
        paddingTop: '0.5rem',
        paddingBottom: '0.5rem',
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      formControl: {
        fontSize: '0.875rem',
      },
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      inputRoot: {
        paddingTop: '0.3rem',
        paddingBottom: '0.3rem !important',
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 10,
      },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      root: {
        padding: theme.spacing(2, 4),
      },
      action: {
        marginTop: 0,
      },
    },
  },
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        fontSize: 14,
      },
    },
  },
};

export type Theme = typeof theme;

export default theme;
